import React, { useState } from "react";
import news from "./populateNews";
import { NewsItem } from "../../shared/types";
import Carousel from "react-slick";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

type Props = {};
interface ArrowProps {
  onClick?: () => void;
}

function NewsPage({}: Props) {
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);

  const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <div
      className="absolute top-1/2 left-4 cursor-pointer text-palette1 z-10"
      onClick={() => {
        console.log("Back arrow clicked");
        onClick?.();
      }}
    >
      <FiChevronLeft size={24} />
    </div>
  );

  const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <div
      className="absolute top-1/2 right-4 cursor-pointer text-palette1 z-10"
      onClick={() => {
        console.log("Next arrow clicked");
        onClick?.();
      }}
    >
      <FiChevronRight size={24} />
    </div>
  );

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // ... (previous code)

  const handleImageClick = (image: string) => {
    setSelectedImage(image);
  };

  const closeImagePopup = () => {
    setSelectedImage(null);
  };

  const handleNewsClick = (newsItem: NewsItem) => {
    setSelectedNews(newsItem);
  };

  const handleCloseNews = () => {
    setSelectedNews(null);
  };

  const openNewsPopup = (newsItem: NewsItem) => {
    setSelectedNews((prevNews) => (newsItem === prevNews ? null : newsItem));
    window.scrollTo(0, 0);
    // Set the cover image to the first image in the array of images
  };

  return (
    <div className="bg-gray-100 w-full text-center h-full sm:h-full pb-8 2xl:h-full 2xl:py-40 flex flex-col justify-center items-center  px-8 lg:px-16">
      <div className="container mx-auto text-center mb-8">
        <h1 className="2xl:text-7xl lg:text-6xl  font-bold text-4xl mt-24 text-center  text-palette1 mb-6 lg:mb-6">
          All News
        </h1>
        <p className="text-gray-950 2xl:text-4xl lg:text-xl ">
          Stay Updated: Explore All the Latest News
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {news.map((newsItem: NewsItem, index: number) => (
          <div
            key={index}
            className={`bg-white  rounded-md shadow-md ${
              selectedNews && selectedNews.title === newsItem.title
                ? "col-span-full order-first"
                : ""
            }`}
          >
            <div>
              {newsItem.images &&
                newsItem.images.length > 0 &&
                (selectedNews?.title !== newsItem.title || !selectedNews) && (
                  <img
                    src={newsItem.images[0]}
                    alt={`News ${index + 1}`}
                    className="w-full h-64 object-cover rounded-t-md "
                  />
                )}

              <div
                className="p-6 cursor-pointer"
                onClick={() => openNewsPopup(newsItem)}
              >
                <h3 className="text-xl lg:text-2xl font-bold text-palette1 mb-2">
                  {newsItem.title}
                </h3>
                <p className="text-sm lg:text-base text-palette3 font-semibold mb-2">
                  {newsItem.date}
                </p>
                <p className="text-sm lg:text-base text-palette1">
                  {newsItem.shortContent == ""
                    ? newsItem.content
                    : newsItem.shortContent}
                </p>
              </div>

              {selectedNews && selectedNews.title === newsItem.title && (
                <div className="px-6 w-full bg-white mb-8 text-justify">
                  <p className="text-sm lg:text-base text-palette1 mb-4">
                    {newsItem.shortContent == "" ? "" : newsItem.content}
                  </p>
                  {selectedNews.images && selectedNews.images.length > 0 && (
                    <Carousel
                      arrows={selectedNews.images.length > 1}
                      prevArrow={<PrevArrow />}
                      nextArrow={<NextArrow />}
                    >
                      {selectedNews.images.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={image}
                          className="w-auto object-contain h-64 mb-2"
                          onClick={() => handleImageClick(image)}
                        />
                      ))}
                    </Carousel>
                  )}
                  {selectedNews.link && (
                    <div className="text-center my-8">
                      <a
                        href={selectedNews.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-palette3 font-semibold hover:underline mt-2 inline-block"
                      >
                        Read More
                      </a>
                    </div>
                  )}
                  {selectedNews.dissemination && (
                    <div className="flex flex-col gap-2">
                      <p>{selectedNews.dissemination.text}</p>
                      {selectedNews.dissemination.urls.map(
                        (dissemination, index) => (
                          <div>
                            <ul className="list-disc lg:px-16 pl-6">
                              <li>
                                <p className="text-palette1 text-justify mt-8">
                                  {dissemination.name}
                                </p>
                                {dissemination.url && (
                                  <a
                                    className="text-palette3 mt-4 hover:underline inline-block"
                                    href={dissemination.url}
                                    target="_new"
                                  >
                                    Read Article
                                  </a>
                                )}
                              </li>
                            </ul>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {selectedImage && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-palette1 bg-opacity-80 flex items-center justify-center"
          onClick={closeImagePopup}
        >
          <img src={selectedImage} alt="popup" className="h-[calc(70vh)]" />
        </div>
      )}
    </div>
  );
}

export default NewsPage;
